// Import React libs
import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
// import { Analytics } from '@vercel/analytics/react';
import ScrollToTop from "./Components/ScrollToTop";
// Import Pages
import App from "./App";
// Import Css
import './Assets/Css/Reset.css'
import './Assets/Css/Global.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
      {/* <Analytics /> */}
    </BrowserRouter>
  </React.StrictMode>
);